import { render, staticRenderFns } from "./ClientEmailEventsContainer.vue?vue&type=template&id=049fc48a&scoped=true&"
import script from "./ClientEmailEventsContainer.vue?vue&type=script&lang=js&"
export * from "./ClientEmailEventsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049fc48a",
  null
  
)

export default component.exports